// extracted by mini-css-extract-plugin
export default {"subtitle__icon-container":"style_subtitle__icon-container__co1hB","subtitle__text":"style_subtitle__text__lbvDb"};